import { render, staticRenderFns } from "./FeeCalculator.vue?vue&type=template&id=3e5dcece"
import script from "./FeeCalculator.vue?vue&type=script&lang=js"
export * from "./FeeCalculator.vue?vue&type=script&lang=js"
import style0 from "./FeeCalculator.vue?vue&type=style&index=0&id=3e5dcece&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports